"use client";
// TODO: 半星icon替换
import React, { useCallback, useMemo, useState } from "react";
import { EIconType } from "@/public/static/interface";
import { IconContainerProps, Rating, RatingProps } from "@mui/material";
import stl from "../styles/rating.module.scss";
import classnames from "classnames";
import FmIcon from "./FmIcon";
interface IProps extends RatingProps {
    icon?: EIconType;
    iconClassName?: string;
    min?: number; // 最小星号是0
    formatStarNum?: (value: number) => string; // 显示starNum, 一般来说其实是规范value值显示问题
    starNumClassName?: string;
    hiddenRatingNum?: boolean; // 是否隐藏星星数量
}
const FmRating: React.FC<IProps> = (props) => {
    const {
        onChange,
        iconClassName,
        formatStarNum,
        starNumClassName,
        min = 0,
        hiddenRatingNum = false,
        ...restprops
    } = props;
    const [hoverValue, setHoverValue] = useState(-1);

    const handleChange = useCallback(
        (event: React.SyntheticEvent<Element, Event>, value: number | null) => {
            if (!value) {
                // 点击已经变色的icon会得到null的值
                return;
            }
            onChange?.(event, Number(value) < min ? min : Number(value));
        },
        [min, onChange],
    );

    const showRating = useMemo(() => {
        return hoverValue !== -1 ? hoverValue : props.value;
    }, [hoverValue, props.value]);

    // function IconContainer(props: IconContainerProps) {
    //     const { value, ...other } = props;
    //     console.log("value", value, other);

    //     return <FmIcon icon={"icon--star2"} />;
    //     // <span {...other}>{customIcons[value].icon}</span>;
    // }

    return (
        <div className={stl["rating-container"]}>
            <Rating
                name={props.name}
                precision={props.precision ?? 0.5} // 允许半粒
                onChange={handleChange}
                onChangeActive={(event, newHover) => setHoverValue(newHover)}
                classes={{ icon: iconClassName }}
                value={props.value}
                {...restprops}
                // icon={<FmIcon icon={"icon--full-star"} />}
                // emptyIcon={<FmIcon icon={"icon--star2"} />}
                // IconContainerComponent={IconContainer}
            />
            {!hiddenRatingNum && (
                <p
                    className={classnames(
                        stl["show-star-numbers"],
                        {
                            ["hidden"]: !props.value,
                        },
                        starNumClassName,
                    )}
                    style={{ color: props.color }}
                >
                    {typeof formatStarNum === "function" && showRating
                        ? formatStarNum?.(showRating)
                        : showRating ?? null}
                </p>
            )}
        </div>
    );
};

export default FmRating;
